import { createFileRoute } from '@tanstack/react-router';

import { ListingEditorPage } from '@/features/land/listing-editor-page';

export const Route = createFileRoute('/_app/land/sell/$orgId/listings/$listingId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId, listingId } = Route.useParams();
  return <ListingEditorPage orgId={orgId} listingId={listingId} />;
}
